import {pluck} from 'ramda';
import React from 'react';
import Select from 'react-select';
import {Option as MutableOption, theme} from './Common';

type Options<Value> = readonly MutableOption<Value>[];

export type MultiSelectProps<Value> = {
  options: Options<Value>;
  value?: Maybe<Value[]>;
  onChange?: (arg: Value[]) => void;
  placeholder?: string;
  isClearable?: boolean;
  isDisabled?: boolean;
  isLarge?: boolean;
};

export function MultiSelect<Value>({
  options,
  value,
  onChange,
  placeholder,
  isClearable,
  isDisabled,
  isLarge,
}: MultiSelectProps<Value>) {
  return (
    <Select
      isMulti={true}
      options={options}
      value={options?.filter(option => (value || []).includes(option.value))}
      placeholder={placeholder}
      isClearable={isClearable === null || isClearable === undefined ? true : isClearable}
      isDisabled={isDisabled}
      onChange={(option: Options<Value>) => onChange?.(pluck('value', option))}
      styles={{
        menu: () => ({
          width: isLarge ? '100%' : '130px',
          border: '1px solid #2E3192',
          borderTop: 'transparent',
          color: '#2E3192',
          display: 'flex',
          alignItems: 'center',
          background: 'red',
          zIndex: 1,
        }),
        menuList: () => ({
          zIndex: 1,
          width: isLarge ? '100%' : '130px',
          background: 'white',
          borderRight: '1px solid #2E3192',
          borderLeft: '1px solid #2E3192',
        }),
        menuPortal: () => ({
          zIndex: 99,
        }),
        singleValue: () => ({
          zIndex: 99,
        }),
        control: () => ({
          width: isLarge ? '100%' : '130px',
          paddingTop: 8,
          paddingBottom: 8,
          color: '#2E3192',
          position: positionType.relative,
        }),
        indicatorsContainer: () => ({
          position: positionType.absolute,
          right: 0,
          top: '25%',
          color: '#2E3192',
        }),
        dropdownIndicator: () => ({
          color: '#2E3192',
        }),
        placeholder: () => ({
          color: '#2E3192',
        }),
        clearIndicator: () => ({
          display: 'none',
        }),
        container: () => ({
          position: 'relative',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          width: isLarge ? '100%' : '130px',
          height: 49,
          border: `1px solid ${theme.colors.darkBlue}`,
          padding: `0 ${theme.spacings.xxsmall}`,
          transition: `border 0.1s ease-in-out`,
          lineHeight: 1,
          background: theme.colors.white,
          '&:hover': {
            border: isDisabled
              ? `1px solid ${theme.colors.darkBlue}`
              : `2px solid ${theme.colors.darkBlue}`,
          },
          opacity: isDisabled ? 0.5 : 1,
        }),
      }}
    />
  );
}

enum positionType {
  relative = 'relative',
  absolute = 'absolute',
}
